import { MenuOption } from '@lexical/react/LexicalTypeaheadMenuPlugin';

class MentionTypeaheadOption extends MenuOption {
  userId;
  userName;
  userPhoto;
  userUsername;

  constructor({ userId, userName, userUsername, userPhoto }) {
    super(userUsername);

    this.userId = userId;
    this.userName = userName;
    this.userPhoto = userPhoto;
    this.userUsername = userUsername;
  }
}

export default MentionTypeaheadOption;
